<template>
    <div class="login">
        <div class="columns">
            <div class='column is-4 is-offset-4'>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <div v-if="logoutMessage" class="logout-message">
                {{ logoutMessage }}
                </div>
                <form @submit.prevent="login" method="POST">
                    <div class='column is-horizontal-center top-logo'>
                          <figure class='image'>
                            <img src="../../assets/images/lango.png">
                        </figure>
                    </div>
                    <div v-if="isInvalid" class="invalid help is-danger is-danger-username" style="margin-bottom: 5px; font-size: 14px;">Invalid username and password.</div>
                    <div v-else-if="accountLockedType === 'temporary'" class="account-locked-message account-locked-temporary">
                        Your account has been temporarily locked. Please try again in 5 minutes or contact support to have it unlocked.
                    </div>
                    <div v-else-if="accountLockedType === 'permanent'" class="account-locked-message account-locked-permanent">
                        Your account has been permanently locked. Please contact support to have it unlocked.
                    </div>
                    <div class="field">
                        <label class="label">Login</label>
                        <div class="control has-icons-left">
                            <input class="input is-medium login-input" v-bind:class="{ 'is-danger': usernameErr }" type="text" placeholder="Account Email" v-model="username" @focus="clearErrorMsgs">
                            <span class="icon is-small is-left">
                                <icon name="user"></icon>
                            </span>
                        </div>
                        <p v-show="usernameErr" class="help is-danger is-danger-username">Username is required</p>
                    </div>
                    <div class="field" style="margin-top: 25px;">
                        <label class="label">Password</label>
                        <div class="control has-icons-left has-icons-right">
                            <input class="input is-medium" v-bind:class="{ 'is-danger': passwordErr }" :type="showPassword ? 'text' : 'password'" placeholder="Password" v-model="password" @focus="clearErrorMsgs">
                            <span class="icon is-small is-left">
                                <icon name="key"></icon>
                            </span>
                            <button type="button" class="icon is-small is-right password-toggle" @click.prevent="togglePasswordVisibility" aria-label="Toggle password visibility">
                                <icon :name="showPassword ? 'eye-slash' : 'eye'"></icon>
                            </button>
                        </div>
                        <p v-show="passwordErr" class="help is-danger is-danger-password">Password is required</p>
                    </div>
                    <div class="field" style="margin-top: 25px;">
                        <button class="button is-link login-link" v-bind:class="{ 'is-loading': isActive}">Sign In</button>
                    </div>
                    <div class="field">
                        <div class="password-reset">
                            <p class="forgot-username" v-on:click="forgotPassword">Forgot your password?</p>
                        </div>
                    </div>
                </form>
            </div>
        </div>

    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    data () {
        return {
            username: '',
            password: '',
            showPassword: false,
            logoutMessage: null,
        }
    },

    computed: {
        ...mapState('auth', {
            isActive: state => state.isActive,
            usernameErr: state => state.usernameErr,
            passwordErr: state => state.passwordErr,
            isInvalid: state => state.isInvalid,
            accountLockedType: state => state.accountLockedType,
        }),

        ...mapGetters('auth', {
            isInvalid: 'getInvalid',
        })
    },

    created() {
        const message = sessionStorage.getItem('logoutReason')

        if (message) {
            this.logoutMessage = message
            sessionStorage.removeItem('logoutReason')
        }
    },

    methods: {
        login(){
            var thisLogin = this;

            VueStore.dispatch('auth/setBoolean', {key: 'isActive', bool: true});

            var logged_in = 0;

            if(_.trim(thisLogin.username) === ''){
                VueStore.dispatch('auth/setBoolean', {key: 'usernameErr', bool: true});
                logged_in++;
            }

            if(_.trim(thisLogin.password) === ''){
                VueStore.dispatch('auth/setBoolean', {key: 'passwordErr', bool: true});
                logged_in++;
            }

            if(logged_in == 0){
                var user = {
                  username: thisLogin.username,
                  password: thisLogin.password
                };

                // call authenticate action
                VueStore.dispatch('auth/authenticate', user);

            } else {
                VueStore.dispatch('auth/setBoolean', {key: 'isActive', bool: false});
            }

        },

        clearErrorMsgs(){
            VueStore.dispatch('auth/setBoolean', {key: 'usernameErr', bool: false});
            VueStore.dispatch('auth/setBoolean', {key: 'passwordErr', bool: false});
            VueStore.dispatch('auth/setAccountLockedType', null);
        },

        forgotPassword(){
            window.location.href = '/forgot-password';
        },

        togglePasswordVisibility(){
            this.showPassword = !this.showPassword;
        }
    },

    mounted(){
        // retrive environment variables and stored in vuex.
        VueStore.dispatch('auth/setVariables');

        //sessionStorage.removeItem("TOKEN")
        //sessionStorage.removeItem("USER")
    }
};
</script>


<style>
.top-logo {
    display: flex;
    justify-content: center;
}

.top-logo .image {
    width: auto;
}

.top-logo .image img {
    width: auto;
    max-width: 100%;
}

.logout-message {
  background: #fff3cd;
  border: 1px solid #ffeeba;
  color: #856404;
  padding: 12px;
  margin-bottom: 16px;
  border-radius: 4px;
}

.account-locked-message {
  padding: 12px;
  margin-bottom: 16px;
  border-radius: 4px;
  font-size: 14px;
}

.account-locked-temporary {
  background: #fff3cd;
  border: 1px solid #ffeeba;
  color: #856404;
}

.account-locked-permanent {
  background: #f8d7da;
  border: 1px solid #f5c6cb;
  color: #721c24;
}

.control.has-icons-right .icon.password-toggle {
  cursor: pointer;
  pointer-events: auto;
  z-index: 2;
  background: transparent;
  border: none;
  padding: 0;
}

.control.has-icons-right .icon.password-toggle:hover {
  color: #5179D6;
}

/* Mobile: the is-4/is-offset-4 column is a desktop layout; make the form
   full-width and keep the field values at 16px+ so iOS Safari does not
   auto-zoom into the field on focus (which made saved credentials appear
   to "grow" when tapped). */
@media screen and (max-width: 768px){
  .login .columns {
    margin-left: 0;
    margin-right: 0;
  }
  .login .column.is-4 {
    width: 100%;
    margin-left: 0 !important;
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .login .input {
    font-size: 16px !important;
  }
  /* Keep the input text clear of the left/right field icons: the icon
     padding is em-based, so it shrinks when the font-size is forced to 16px. */
  .login .control.has-icons-left .input {
    padding-left: 2.75rem;
  }
  .login .control.has-icons-right .input {
    padding-right: 2.75rem;
  }
}

</style>
